import type { FileUIPart } from 'ai';

import type { LeDataImageAttachment, LeDataImageMediaType } from '~/types/leData';

import { fileToComposerImageAttachment } from '../imageAttachments';

import type { AskUIMessage } from './askUiMessage';

export function imagePartOf({ data, mediaType }: LeDataImageAttachment): FileUIPart {
  return { type: 'file', mediaType, url: `data:${mediaType};base64,${data}` };
}

export async function imagePartFromFile(file: File): Promise<FileUIPart> {
  return imagePartOf(await fileToComposerImageAttachment(file));
}

export function imageAttachmentOf(part: FileUIPart): LeDataImageAttachment | null {
  const prefix = `data:${part.mediaType};base64,`;
  return part.url.startsWith(prefix)
    ? { mediaType: part.mediaType as LeDataImageMediaType, data: part.url.slice(prefix.length) }
    : null;
}

export function userImageParts(message: AskUIMessage): Array<FileUIPart> {
  return message.parts.filter(
    (part): part is FileUIPart => part.type === 'file' && part.mediaType.startsWith('image/'),
  );
}
